import api from '../../config/api_config';

export const ordersApi = {
    getOrders: (params) => api.get('/orders/', { params }),
    getOrderById: (id) => api.get(`/orders/${id}/`),
    createOrder: (data) => api.post('/orders/', data),
    updateOrder: (id, data) => api.put(`/orders/${id}/`, data),
    cancelOrder: (id) => api.post(`/orders/${id}/cancel/`),
    
    // Payment
    initiatePayment: (orderId, method = 'paystack', callbackUrl = '') => 
        api.post(`/orders/${orderId}/initiate-payment/`, { method, callback_url: callbackUrl }),
    verifyPayment: (orderId, reference) => 
        api.post(`/orders/${orderId}/verify-payment/`, { reference })
};